
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 24 24"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Ebene_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 24 24","style":"enable-background:new 0 0 24 24;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M22.8,4.6h-6.1V2.3c0-0.8-0.6-1.4-1.4-1.4H8.8C8,0.8,7.3,1.5,7.3,2.3v2.3H1.2C1,4.6,0.7,4.8,0.7,5.1S1,5.6,1.2,5.6h1.9\n\t\tl1.7,15.7c0.1,1.2,1.1,2.1,2.4,2.1h9.8c1.2,0,2.2-0.9,2.4-2.1l1.7-15.7h1.9c0.3,0,0.5-0.2,0.5-0.5S23.1,4.6,22.8,4.6z M8.3,2.3\n\t\tc0-0.2,0.2-0.4,0.4-0.4h6.6c0.2,0,0.4,0.2,0.4,0.4v2.3H8.3V2.3z M18.3,21.2c-0.1,0.7-0.7,1.2-1.4,1.2H7.2c-0.7,0-1.3-0.5-1.4-1.2\n\t\tL4.1,5.6h15.8L18.3,21.2z"}}),_c('path',{attrs:{"d":"M12,8.8c-0.3,0-0.5,0.2-0.5,0.5v9.9c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V9.3C12.5,9,12.3,8.8,12,8.8z"}}),_c('path',{attrs:{"d":"M15.8,9.3l-0.5,9.9c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0c0.3,0,0.5-0.2,0.5-0.5l0.5-9.9c0-0.3-0.2-0.5-0.5-0.5\n\t\tC16,8.8,15.8,9,15.8,9.3z"}}),_c('path',{attrs:{"d":"M7.8,8.8c-0.3,0-0.5,0.2-0.5,0.5l0.5,9.9c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0c0.3,0,0.5-0.2,0.5-0.5L8.3,9.3\n\t\tC8.3,9,8.1,8.8,7.8,8.8z"}})])])
          )
        }
      }
    